import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {
  BrowserRouter as Router,
} from 'react-router-dom';
import {Provider} from 'react-redux';
import {createStore} from 'redux'
import rootReducer from './reducers'
import {loadFromLocalStorage} from './reducers/index'
import {requestConfig, responseConfig} from './interceptor';

const persistedState = loadFromLocalStorage()

requestConfig()
responseConfig()

const store = createStore(
  rootReducer,
  persistedState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() 
)


ReactDOM.render(
  <>
  <Provider store={store}>
    <Router>
      <App />
    </Router>
    </Provider>
  </>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
